var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-box"},[_c('img',{staticClass:"guide-img",attrs:{"src":("http://www.artgogo.com/online-exhibition/amicitia/img/" + _vm.src)}}),_c('ChangeButton',{on:{"change":_vm.changeLanguage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }